import styled from "styled-components";
import { breakpoints, colors } from "src/variables";

export const ImageContainer = styled.div<{ backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor || colors.white};
  display: flex;
  justify-content: center;
  width: 100%;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    background: ${colors.magenta};
    margin-bottom: -1px;
  }
`;

export const Image = styled.img<{
  webImageSrc: string;
  mobileImageSrc: string;
}>`
  max-width: 1680px;
  display: block;
  width: 100%;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    content: url(${(props) => props.mobileImageSrc});
  }

  @media (min-width: ${breakpoints.tabletPortrait + 1}px) {
    content: url(${(props) => props.webImageSrc});
  }
`;
